import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dhhp-card-title',
  template: `<mat-card-title>
    <ng-content></ng-content>
  </mat-card-title>`
})
export class DhhpCardTitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
